import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import loadable from '@loadable/component';

import { Helpers } from '../../core';
import usePage from '../../hooks/usePage';
import withPageComponents from '../../page/components/with-page-components';
import { StoreAppAPI } from '../../core/src/storeapp-api-client';
import { getValidIntopicBlogSubcat } from '../util';

import './vwa-intopic-articles.less';

const IntopicArticles = loadable(() => Helpers.retryFunc(() => import('../../shared/components/intopic-articles')));

const storeAppAPI = new StoreAppAPI();

const getIntopicBlogsMemoized = Helpers.memoize(categories => (
    storeAppAPI.page.getIntopicBlogs(categories)
), (categories) => Array.isArray(categories) ? categories.join('-') : '')


const getCategoryKeys = cats => Array.isArray(cats) ? cats.join('-') : null;

const VWAIntopicArticles = ({ intopicArticles }) => {
    const { blogs, categories } = intopicArticles || {};
    const { updateComponent } = usePage();

    // categories to check when changing filters in the Accessories VWA
    const accessoryCategories = useSelector(state => {
        try{
            const pathname = state.router.location.pathname;
            const slugAndFilter = pathname && pathname.split(/vwa\//i).pop();
            const [slug, filters] = slugAndFilter.split('/'); 
            const isAccessory = /accessories/gi.test(slug)
            const validSubCats = isAccessory && getValidIntopicBlogSubcat(filters)
            return validSubCats && validSubCats.length > 0 ? validSubCats : isAccessory ? ['accessories'] : null;
        }catch(e){}
    });

    const accessoryCatKeys = getCategoryKeys(accessoryCategories);
    const categoryKeys = getCategoryKeys(categories);

    useEffect(() => {
        // update components in the Accessories VWA when a valid subcategory filter is used after async components have been fetched
        if(intopicArticles && accessoryCategories && accessoryCategories.length > 0 && accessoryCatKeys !== categoryKeys){
            try{
                getIntopicBlogsMemoized(accessoryCategories).then(intopicBlogs => {
                    const newComponent = {
                        intopicArticles: {
                            ...intopicBlogs || {},
                            categories: accessoryCategories
                        }
                    }
                    updateComponent(newComponent, (state, nextState) => {
                        return {
                            ...state || {},
                            components: {
                                ...(state && state.components) || {},
                                intopicArticles: newComponent.intopicArticles
                            },
                        };
                    })
                })
            }catch(e){}
        }
    }, [accessoryCatKeys])

    return Array.isArray(blogs) && blogs.length > 0 && (
        <div className='vwa-intopic-articles-section'>
            <IntopicArticles blogs={blogs} />
        </div>
    )    
};

export default withPageComponents(VWAIntopicArticles, { components: ['intopicArticles'] });